import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserInfo} from '@app/model/user-info.model';
import {LanguageService} from '@app/services/language.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
	@Output() toggleSidenav = new EventEmitter();
	@Input() userInfo?: UserInfo | null;

	constructor(public languageService: LanguageService) {
	}
}
